import { AddToCartType, SaleChannel } from '@/constants'
import { useLocalStorage } from '@/hooks'
import { useCookie } from '@/hooks/useCookie'
import type { BannerList, OrderPaymentMethod, QueryParam, Store } from '@/types'
import {
  type Cart,
  type CartItemType,
  type Installment,
  type User,
  type UserAddress,
} from '@/types'
import { api } from '@/utils'
import { getShippingAddress, getShippingAddressDetail } from '@/utils/endpoint'
import { convertQueryParam } from '@/utils/next-util'
import constate from 'constate'
import { deleteCookie, getCookie, setCookie } from 'cookies-next'
import { isEmpty } from 'lodash'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useStore } from './StoreContainer'

type Props = {
  authToken: string | null
}
interface GlobalError {
  status: boolean
  message: string
  key: string
}
const Container = (props: Props) => {
  const initialCart: Cart = {
    amount: 0,
    products: [],
    coupons: [],
    quantity: 0,
    serviceFee: 0,
    shippingAndInstallFee: 0,
    saleAmount: 0,
    shippingFee: 0,
    discount: 0,
    promotionAmount: 0,
  }
  const GlobalErrorProps: GlobalError = {
    status: false,
    message: '',
    key: '',
  }
  const initialInstallment: Installment = {
    amount: 0,
    products: [],
    quantity: 0,
    serviceFee: 0,
    saleAmount: 0,
    shippingFee: 0,
    discount: 0,
    promotionAmount: 0,
  }
  const router = useRouter()
  const [cart, setCart] = useLocalStorage<Cart>('cart', initialCart)
  const [user, setUser] = useState<User | null>(null)
  const [token, setToken] = useCookie<string | null>(
    'token',
    props.authToken || null
  )
  const [storeList, setStoreList] = useState<Store[] | null>(null)
  const [listBranch, setListBranch] = useState<Store[] | null>(null)
  const [storeSelected, setStoreSelected] = useState<Store | null>(null)
  const [userAddress, setUserAddress] = useState<UserAddress | null>(null)
  const [installment, setInstallment] = useLocalStorage<Installment>(
    'installment',
    initialInstallment
  )

  const [address, setAddress] = useState<UserAddress | null | undefined>()
  const [listAddress, setListAddress] = useState<
    UserAddress[] | null | undefined
  >()
  const [listAddressByRegion, setListAddressByRegion] = useState<
    UserAddress[] | null | undefined
  >()

  const [isOpenListAddress, setIsOpenListAddress] = useState(false)
  const [isOpenAddAddress, setIsOpenAddAddress] = useState(false)
  const [globalLoading, setGlobalLoading] = useState(false)
  const [refetch, setRefetch] = useState(false)
  const [remember, setRemember] = useCookie('remember', true)
  const [guessPhone, setGuessPhone] = useState<string | null>(null)
  const [channel, setChannel] = useCookie('channel', SaleChannel.B2C)
  // const [provinceOfRegion, setProvinceOfRegion] = useState<Region[] | null>(
  //   null
  // )
  const { provinceOfRegion, setSaleRegion, setAreaType } = useStore()
  const currentRegion = getCookie('Area-Code')

  const [paymentMethodAvailable, setPaymentMethodAvailable] = useState<
    OrderPaymentMethod[]
  >([])
  const [accessToken, setAccessToken] = useCookie(
    'access',
    process.env.NEXT_PUBLIC_ACCESS_TOKEN
  )
  const [destinationCode, setDestinationCode] = useCookie<string | null>(
    'destinationCode',
    null
  )
  const [popupMain, setPopupMain] = useState<BannerList | undefined>()
  const [errorAuth, setErrorAuth] = useState<GlobalError | null>(
    GlobalErrorProps
  )
  const [clientIP, setClientIP] = useState<string | null>(null)
  // const [sourceClid, setSourceClid] = useState('')
  // const getProvinceOfRegion = async () => {
  //   const res = await api(`api/sale-region/province`, {
  //     baseURL: process.env.NEXT_PUBLIC_ECOMMERCE_API_URL,
  //     method: 'get',
  //   })

  //   if (res && !(res instanceof Error)) {
  //     setProvinceOfRegion(res.data)
  //     return
  //   }
  // }
  // useEffect(() => {
  //   getProvinceOfRegion()
  // }, [])

  const getPaymentMethodAvailable = async () => {
    try {
      if (cart?.products?.length > 0) {
        const res = await api(`api/payment-methods`, {
          baseURL: process.env.NEXT_PUBLIC_ECOMMERCE_API_URL,
          method: 'post',
          data: {
            productIds: cart?.products?.map((e: CartItemType) => e.productId),
            totalAmount: cart?.amount,
            provinceCode: currentRegion,
            phone: user ? user?.phone : guessPhone || null,
            user,
          },
        })

        if (res && !(res instanceof Error)) {
          setPaymentMethodAvailable(res.data)
          return
        }
      }
    } catch (error) {
      console.error('Error fetching payment method available:', error)
    }
  }
  //   useEffect(() => {
  //     api(`api/area?level=2`, {
  //       method: 'get',
  //       baseURL: process.env.NEXT_PUBLIC_IAM_API_URL,
  //     }).then(async result => {
  //       if (result instanceof Error) {
  //         return
  //       }
  //       if (provinceOfRegion) {
  //         const mappingAddress = result?.data?.map((itemA: UserAddress) => {
  //           const matchB = provinceOfRegion.find(
  //             itemB => itemB.code === itemA.code
  //           )

  //           return {
  //             ...itemA,
  //             saleRegion: matchB?.parentCode || '',
  //           }
  //         })
  //         setListAddressReduce(mappingAddress)
  //       }
  //     })
  //   }, [provinceOfRegion])

  useEffect(() => {
    if (token && getCookie('channel')) {
      const channelData = getCookie('channel')
      setChannel(channelData as SaleChannel)
    }
  }, [token])
  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await fetch('/api/client-ip')
        const data = await response.json()
        setClientIP(data.clientIP)
      } catch (error) {
        console.error('Error fetching IP:', error)
      }
    }
    fetchIP()
  }, [router])

  const logout = async () => {
    const DEFAULT_PROVINCE = process.env.NEXT_PUBLIC_PROVINCE_DEFAULT || '01'
    const DEFAULT_REGION = process.env.NEXT_PUBLIC_SALE_REGION_DEFAULT || 'MB1'

    setUser(null)
    setRemember(false)
    setToken(null)
    setAddress(null)
    await deleteCookie('token')
    await deleteCookie('channel')
    localStorage?.clear()

    // Reset province, Area-Code, area-type về mặc định
    localStorage.setItem('province', DEFAULT_PROVINCE)
    localStorage.setItem('Area-Code', DEFAULT_REGION)
    localStorage.setItem('area-type', 'old')
    localStorage.setItem('area-popup-seen', 'true')

    setCookie('province', DEFAULT_PROVINCE, { maxAge: 2147483647 })
    setCookie('Area-Code', DEFAULT_REGION, { maxAge: 2147483647 })
    setCookie('area-type', 'old', { maxAge: 2147483647 })

    setAreaType('old')
    setSaleRegion(DEFAULT_REGION)

    await window.location.reload()
  }

  const getGuessTokenCart = () => {
    if (token) {
      return null
    }
    let guestId = getCookie('guestId')
    if (guestId) {
      return guestId
    }
    guestId = uuidv4().replaceAll('-', '')
    const expiryDate = new Date()
    expiryDate.setMonth(expiryDate.getMonth() + 1)
    setCookie('guestId', guestId, { expires: expiryDate })
    return guestId
  }

  const fetchProfile = async () => {
    const res = await api(`api/profile`, {
      method: 'GET',
      baseURL: process.env.NEXT_PUBLIC_IAM_API_URL,
    })
    if (res && !(res instanceof Error)) {
      setUser(res.data)
      return
    }
    await logout()
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const fetchCart = async (
    query: {
      wardCode?: string
      shippingMethod?: string
      coupon?: string | string[]
      isPreOrder?: boolean
      productIds?: string
      action?: string
      type?: string
    } = {}
  ) => {
    let params = null
    getPaymentMethodAvailable()
    const queryParams = {
      ...(query.wardCode || destinationCode
        ? { destinationCode: query.wardCode || destinationCode }
        : {}),
      ...(query.shippingMethod ? { shippingMethod: query.shippingMethod } : {}),
      ...(query.coupon ? { coupon: query.coupon } : {}),
      ...(query.isPreOrder ? { isPreOrder: query.isPreOrder } : {}),
      ...(router?.query?.type == AddToCartType.PRE_ORDER
        ? { isPreOrder: true }
        : {}),
      ...(query.productIds ? { productIds: query.productIds } : {}),
      ...(router?.query?.productIds
        ? { productIds: router?.query?.productIds }
        : {}),
    }
    if (!isEmpty(queryParams) && queryParams) {
      params = convertQueryParam(queryParams as QueryParam)
    }
    const token = getGuessTokenCart()
    const res = await api(`api/shopping-cart?${params || ''}`, {
      method: 'GET',
      baseURL: process.env.NEXT_PUBLIC_ECOMMERCE_API_URL,
      ...(token ? { headers: { uuid: token } } : {}),
    })
    if (res instanceof Error) {
      setErrorAuth({ status: true, message: res.message, key: 'fetchCart' })
      throw res
    }
    setCart({
      ...res.data,
      quantity: res?.data?.products?.reduce(
        (acc: number, e: CartItemType) => acc + e?.quantity,
        0
      ),
    })
    return res.data
  }

  const fetchAddress = async () => {
    try {
      // 1. Fetch TẤT CẢ addresses (không lọc province) để tìm default address
      const allRes = await api(
        `api/user-contact?type=shipping&page=1&limit=50`,
        {
          method: 'GET',
          baseURL: process.env.NEXT_PUBLIC_IAM_API_URL,
        }
      )

      if (!allRes || allRes instanceof Error || !allRes.data?.length) return

      // Tìm default address từ toàn bộ danh sách
      const defaultAddress: UserAddress | undefined = allRes.data.find(
        (e: UserAddress) => e.default
      )

      // Nếu có shippingAddress trong URL, ưu tiên dùng đó
      let resolved: UserAddress | undefined
      if (router?.query?.shippingAddress) {
        resolved =
          allRes.data.find(
            (e: UserAddress) => e._id === router.query.shippingAddress
          ) ||
          defaultAddress ||
          allRes.data[0]
      } else {
        resolved = defaultAddress || allRes.data[0]
      }

      // 2. Sync cookies từ default address CHỈ 1 LẦN sau login đầu tiên
      // Flag 'address-synced' ngăn việc ghi đè khi user đã chọn tỉnh khác qua popup
      const hasSynced = localStorage.getItem('address-synced') === 'true'

      if (resolved && !hasSynced) {
        // Lưu giá trị trước khi sync để so sánh
        const prevRegion = getCookie('Area-Code') as string | undefined
        const prevProvince = getCookie('province') as string | undefined
        const prevAreaType = (getCookie('area-type') as string) || 'old'

        // Sync cookies
        if (resolved.provinceCode) {
          localStorage.setItem('province', resolved.provinceCode)
          setCookie('province', resolved.provinceCode, { maxAge: 2147483647 })
        }
        const areaCode = resolved.saleRegionCode
        if (areaCode) {
          localStorage.setItem('Area-Code', areaCode)
          setCookie('Area-Code', areaCode, { maxAge: 2147483647 })
          setSaleRegion(areaCode)
        }
        const resolvedAreaType = resolved.areaType || 'old'
        localStorage.setItem('area-type', resolvedAreaType)
        setCookie('area-type', resolvedAreaType, { maxAge: 2147483647 })
        setAreaType(resolvedAreaType)

        // Đánh dấu đã sync xong
        localStorage.setItem('address-synced', 'true')

        // Nếu region/province/areaType thay đổi → refetch data thay vì reload page
        // (tránh double load khi vừa login xong đã full reload rồi)
        const newRegion = resolved.saleRegionCode
        const newProvince = resolved.provinceCode
        if (
          (newRegion && newRegion !== prevRegion) ||
          (newProvince && newProvince !== prevProvince) ||
          resolvedAreaType !== prevAreaType
        ) {
          setRefetch(true)
        }
      }

      // 3. Set userAddress cho checkout (luôn chạy)
      if (resolved) {
        // Nếu có shippingAddress trong URL → luôn dùng resolved (address từ URL)
        // Không override bằng matchingAddr vì provinceCode có thể trùng giữa old/new areaType
        if (router?.query?.shippingAddress) {
          setUserAddress(resolved)
          // Sync cookies theo địa chỉ được chọn từ sổ địa chỉ
          if (resolved.provinceCode) {
            localStorage.setItem('province', resolved.provinceCode)
            setCookie('province', resolved.provinceCode, { maxAge: 2147483647 })
          }
          if (resolved.saleRegionCode) {
            localStorage.setItem('Area-Code', resolved.saleRegionCode)
            setCookie('Area-Code', resolved.saleRegionCode, {
              maxAge: 2147483647,
            })
            setSaleRegion(resolved.saleRegionCode)
          }
          const selectedAreaType = resolved.areaType || 'old'
          localStorage.setItem('area-type', selectedAreaType)
          setCookie('area-type', selectedAreaType, { maxAge: 2147483647 })
          setAreaType(selectedAreaType)
        } else {
          // Trường hợp không có shippingAddress → ưu tiên address khớp province đang chọn
          const currentProv = getCookie('province') as string
          const currentAreaType = getCookie('area-type') as string
          // Ưu tiên: địa chỉ default trong cùng province + areaType
          const matchingAddr = allRes.data.find(
            (e: UserAddress) =>
              e.provinceCode === currentProv &&
              e.areaType === currentAreaType &&
              e.default
          ) || allRes.data.find(
            (e: UserAddress) =>
              e.provinceCode === currentProv && e.areaType === currentAreaType
          )
          // Fallback: dùng resolved (địa chỉ default chung) thay vì null
          // để tránh hiển thị sai thông tin khi province cookie chưa sync
          setUserAddress(matchingAddr || resolved || null)
        }
      }

      // 4. Lọc danh sách theo region cho listAddressByRegion
      if (provinceOfRegion) {
        const regionCode =
          (getCookie('Area-Code') as string) ||
          resolved?.saleRegionCode ||
          currentRegion
        const regionProvinces = provinceOfRegion
          ?.filter(e => e.parentCode === regionCode)
          .map(item => item.code)

        const filteredByRegion = allRes.data.filter((addr: UserAddress) =>
          regionProvinces?.includes(addr.provinceCode)
        )
        setListAddressByRegion(filteredByRegion)
      }
    } catch (error: unknown) {
      console.error('Error fetching address:', error)
      // Chỉ logout nếu unauthorized, không logout khi network fail
      const status = (error as { response?: { status?: number } })?.response
        ?.status
      if (status === 401 || status === 403) {
        await logout()
      }
    }
  }

  const fetchPopup = async (): Promise<BannerList | undefined> => {
    const res = await api(`api/banners?type=fullPopup`, {
      baseURL: process.env.NEXT_PUBLIC_MARKETING_API_URL,
      method: 'get',
    })
    if (res && !(res instanceof Error)) {
      setPopupMain(res?.data.data[0])
    }
    return
  }

  useEffect(() => {
    if (props.authToken && !token) {
      setToken(props.authToken)
    }
  }, [props.authToken])

  useEffect(() => {
    fetchPopup()
  }, [])

  useEffect(() => {
    if (token) {
      fetchProfile()

      if (provinceOfRegion) {
        fetchAddress()
      }
    }
    fetchCart()
  }, [token, refetch, provinceOfRegion])
  const fieldsWithClid = Object.keys(router.query).filter(key =>
    key.includes('clid')
  )
  const getSourceClid = () => {
    if (fieldsWithClid.length > 0) {
      switch (fieldsWithClid[0]) {
        case 'fbclid':
          return 'Facebook'
        case 'twclid':
          return 'Twitter'
        case 'ttclid':
          return 'Tiktok'
        case 'gclid':
          return 'Google Ads'
        case 'zaclid':
          return 'Zalo Ads'

        default:
          return fieldsWithClid[0]
      }
    } else {
      return ''
    }
  }

  const sourceClid = getSourceClid()

  const checkVisitor = async () => {
    const data = {
      ip: clientIP,
      branchCode: router?.query?.tt || null,
      staff: router?.query?.nv || null,
      program: router?.query?.ct || null,
      utm_campaign: router?.query?.utm_campaign || null,
      source: router?.query?.utm_source || sourceClid || null,
      path: router?.asPath,
    }

    await api(`api/access`, {
      method: 'POST',
      baseURL: process.env.NEXT_PUBLIC_LOG_API_URL,
      data: data,
    })

    return
  }
  const getListStore = async (
    query: {
      districtCode?: string
      provinceCode?: string
      productId?: string
    } = {}
  ) => {
    let params = null
    if (!isEmpty(query) && query) {
      params = convertQueryParam(query as QueryParam)
    }
    setGlobalLoading(true)
    const res = await api(`api/store?${params || ''}`, {
      method: 'GET',
      baseURL: process.env.NEXT_PUBLIC_ECOMMERCE_API_URL,
    })
    setGlobalLoading(false)
    if (res && !(res instanceof Error)) {
      setStoreList(res.data)
      return
    }
  }
  const getListBranch = async (
    query: {
      districtCode?: string
      provinceCode?: string
      productId?: string
    } = {}
  ) => {
    let params = null
    if (!isEmpty(query) && query) {
      params = convertQueryParam(query as QueryParam)
    }
    setGlobalLoading(true)
    const res = await api(`api/branch?${params || ''}`, {
      method: 'GET',
      baseURL: process.env.NEXT_PUBLIC_IAM_API_URL,
    })
    setGlobalLoading(false)
    if (res && !(res instanceof Error)) {
      const data = res.data.filter(
        (e: { saleRegionCode: string | boolean | null | undefined }) =>
          e.saleRegionCode
      )
      setListBranch(data)
      return
    }
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const visitor = localStorage?.getItem('visitor')
      if (visitor != clientIP) {
        localStorage?.removeItem('visitor')
      }
      if (
        !visitor &&
        clientIP &&
        (router?.query?.tt ||
          router?.query?.ct ||
          router?.query?.nv ||
          sourceClid ||
          router?.query?.utm_source ||
          router?.query?.utm_term ||
          router?.query?.utm_campaign ||
          router?.query?.utm_medium)
      ) {
        checkVisitor()
        localStorage?.setItem('visitor', clientIP)
      }
    }
  }, [clientIP])
  useEffect(() => {
    if (token) {
      getShippingAddress().then(res => {
        // check điều kiện lấy danh sách nằm trong các vùng bán hàng
        // const checkRegionAvailable = res?.filter(e => e.saleRegionCode)
        setListAddress(res as UserAddress[])
      })
    }
    setRefetch(false)
  }, [refetch, token])
  useEffect(() => {
    if (router?.query?.shippingAddress) {
      getShippingAddressDetail(router?.query?.shippingAddress as string).then(
        res => {
          if (res?.provinceCode == currentRegion) {
            setUserAddress(res as UserAddress | null)
          }
        }
      )
    }
    setRefetch(false)
  }, [router.query.shippingAddress, refetch])

  return {
    user,
    cart,
    setCart,
    token,
    storeList,
    setToken,
    setUser,
    logout,
    remember,
    setRemember,
    setDestinationCode,
    destinationCode,
    fetchProfile,
    fetchCart,
    channel,
    setChannel,
    getGuessTokenCart,
    installment,
    getListStore,
    getListBranch,
    setInstallment,
    storeSelected,
    setAddress,
    address,
    fetchAddress,
    setStoreSelected,
    userAddress,
    setUserAddress,
    fetchPopup,
    listAddress,
    setListAddress,
    listAddressByRegion,
    setListAddressByRegion,
    popupMain,
    isOpenAddAddress,
    isOpenListAddress,
    setIsOpenListAddress,
    setIsOpenAddAddress,
    refetch,
    setRefetch,
    globalLoading,
    errorAuth,
    setErrorAuth,
    clientIP,
    accessToken,
    setAccessToken,
    listBranch,
    setListBranch,
    paymentMethodAvailable,
    setPaymentMethodAvailable,
    getPaymentMethodAvailable,
    guessPhone,
    setGuessPhone,
  }
}

export const [AuthProvider, useAuth] = constate(Container)
